import { Link } from "@tanstack/react-router"
import { ArrowUp, Globe, ShieldCheck } from "lucide-react"

export function Footer() {
  const currentYear = new Date().getFullYear()

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleScrollTo = (id: string) => {
    const el = document.querySelector(id)
    if (el) {
      el.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <footer className="w-full mt-auto bg-surface-container-highest/70 border-t border-outline-variant/60">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center px-6 py-12 max-w-7xl mx-auto gap-8 lg:px-8">
        
        {/* Brand Block */}
        <div className="flex flex-col gap-3 max-w-sm">
          <Link to="/" className="font-sans text-2xl font-black text-on-surface select-none flex items-center gap-1">
            <span className="text-primary">E</span>NGA
          </Link>
          <p className="text-secondary text-xs md:text-sm leading-relaxed">
            The world's most intelligent B2B trade platform for automated procurement, verified sourcing, and dispute-free milestone escrow.
          </p>
        </div>

        {/* Navigation & Back to Top Column */}
        <div className="flex flex-col md:items-end gap-4 w-full md:w-auto">
          <div className="flex flex-wrap gap-x-6 gap-y-2 items-center text-sm font-semibold text-secondary">
            <button
              onClick={() => handleScrollTo("#how-it-works")}
              className="hover:text-primary transition-colors cursor-pointer"
            >
              How it works
            </button>
            <Link
              to="/signup"
              search={{ role: "buyer" }}
              className="hover:text-primary transition-colors"
            >
              For Buyers
            </Link>
            <Link
              to="/signup"
              search={{ role: "seller" }}
              className="hover:text-primary transition-colors"
            >
              For Sellers
            </Link>
            <Link
              to="/explore/suppliers"
              className="hover:text-primary transition-colors"
            >
              Explore Sourcing
            </Link>
          </div>

          <div className="flex items-center justify-between md:justify-end gap-6 w-full pt-4 border-t border-outline-variant/40 text-xs text-secondary">
            <span>&copy; {currentYear} ENGA Inc. All rights reserved.</span>
            <button
              onClick={handleScrollToTop}
              className="flex items-center gap-1.5 hover:text-primary transition-colors cursor-pointer font-bold"
            >
              <span>Back to top</span>
              <ArrowUp className="size-3.5" />
            </button>
          </div>
        </div>

      </div>
    </footer>
  )
}